import { useGlobalContext } from '../context'

function Werewolf() {
    const { players, index, vote, openWaitingScreen, turns, bite } = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}(Werewolf)</h4>
            <p className='text-center'>Like the vampires were not enough, you came from the "Doggo Land" to bring terror to the villagers.Each turn you can select a player to turn them into a baby werewolf who is 
            absolutely harmless, cute little dog.Your goal is simple, you want to leave the village with as many baby werewolfs as possible.Why do you want to do that??Because your wife always wanted to have children but
            you were neutered by your former owner...You can't let your wife down!If you turn all players into werewolves, you win!Now go have some babies!
            </p>
            <div className='d-flex'>
                <img src={`./img/${currentPlayer.class}.png`} alt="" />
                <div className='btn-holder'>{
                    players.map((player, index) => {
                        if (player.class === 'werewolf' || player.class === 'babywerewolf' )
                            return (<button className='btn btn-gradient border' disabled='disabled' key={index}>{player.name}</button>)
                        else 
                            return (<button disabled={vote ? 'disabled' : ''} className={turns === 0 ? 'hidden' : 'btn btn-dark'} onClick={(e) => { bite(index); e.target.classList.add('selected') }} key={index}>{`${player.name}`}</button>)
                            
                           
                    })
                }
                </div>
            </div>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default Werewolf;